export default __webpack_public_path__ + "media/images/icons/play-pause-93aee50dcaa345d016ff815d4ada57a0.svg";